<button
  type="button"
  mat-icon-button
  aria-label="delete"
  (click)="onDelete($event)"
  [disabled]="isLoading"
  matTooltip="{{ 'UI.Delete' | translate }}"
  [matTooltipPosition]="'above'"
>
  <mat-icon aria-hidden="false" aria-label="delete icon" color="warn">delete</mat-icon>
</button>
